/**
 * Variant weight codes aligned with treez-tlp `utils/opensearch.ts` `mapVariantType`.
 */
type VariantTypeInput = {
    amount?: number;
    unitOfMeasurement?: string;
};

const mapVariantType = ({
    amount,
    unitOfMeasurement,
}: VariantTypeInput): string => {
    if (unitOfMeasurement === "MILLIGRAMS" || unitOfMeasurement === "UNIT") {
        return "each";
    }

    if (unitOfMeasurement === "OUNCES") {
        switch (amount) {
            case 0.125:
                return "eighth_ounce";
            case 0.25:
                return "quarter_ounce";
            case 0.5:
                return "half_ounce";
            case 1:
                return "ounce";
            default:
                return amount && unitOfMeasurement
                    ? `${amount}_${unitOfMeasurement.toLowerCase()}`
                    : "";
        }
    }

    switch (amount) {
        case 0.5:
            return "half_gram";
        case 1:
            return "gram";
        case 2:
            return "two_gram";
        case 3.5:
            return "eighth_ounce";
        case 7:
            return "quarter_ounce";
        case 14:
            return "half_ounce";
        case 28:
            return "ounce";
        default:
            return amount && unitOfMeasurement
                ? `${amount}_${unitOfMeasurement.toLowerCase()}`
                : "";
    }
};

export { mapVariantType };
